export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d02e05db4b375ecd84fde08f6c286943.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="mb-8">
              <h1 className="text-7xl font-bold text-white leading-tight mb-4" style={{ letterSpacing: '0.02em' }}>
                Modern iOS Applications
              </h1>
              <h2 className="text-7xl font-bold text-white leading-tight mb-4" style={{ letterSpacing: '0.02em' }}>
                For Enhanced Security
              </h2>
              <h2 className="text-7xl font-bold text-white leading-tight" style={{ letterSpacing: '0.02em' }}>
                And User Experience
              </h2>
            </div>
            <div className="inline-flex items-center gap-3 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full">
              <i className="ri-apple-fill text-white text-xl"></i>
              <span className="text-white text-sm font-medium whitespace-nowrap">iOS Platform Specialists</span>
            </div>
          </div>

          <div className="flex justify-end">
            <div className="max-w-md">
              <p className="text-white text-xl leading-relaxed font-light" style={{ lineHeight: '1.8' }}>
                NOLIOT d. o. o. is a team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-12 right-12 z-10">
        <div className="relative w-64 h-96 transform rotate-y-12" style={{ transform: 'perspective(1000px) rotateY(15deg)' }}>
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20iPhone%20mockup%20displaying%20sleek%20VPN%20application%20interface%20with%20purple%20blue%20gradient%20design%2C%20clean%20iOS%20app%20screen%20showing%20security%20features%20and%20connection%20status%2C%20professional%20mobile%20app%20UI%20design%2C%20minimalist%20interface%20with%20elegant%20typography%2C%20premium%20iOS%20application%20showcase&width=400&height=800&seq=hero-device-noliot-002&orientation=portrait"
            alt="App Interface"
            className="w-full h-full object-contain rounded-3xl shadow-2xl"
          />
        </div>
      </div>
    </section>
  );
}
